<p class="info-box-square my-2 p-3">
  @if (iconClasses && !hideIcon) {
    <span class="icon-holder">
      <i [class]="iconClasses"></i>
    </span>
  }
  <span *transloco="let t">
    {{translationKey ? t(translationKey) : text}}
  </span>
</p>
